import { prisma, type Prisma, Tag, SessionTypeTranslation } from "client";

export const createSessionType = async (
  eventId: string,
  translations: SessionTypeTranslation[],
  color?: string
) => {
  try {
    return prisma.sessionType.create({
      data: {
        eventId,
        color,
        translations: {
          createMany: { data: translations },
        },
      },
    });
  } catch (error) {
    console.error("Error creating session type:", error);
    throw new Error("Error creating session type");
  }
};

export const getSessionTypeById = async (id: string) => {
  return prisma.sessionType.findUnique({ where: { id } });
};

export const updateSessionType = async (
  id: string,
  data: Prisma.SessionTypeUpdateInput
) => {
  return prisma.sessionType.update({ where: { id }, data });
};

export const deleteSessionType = async (id: string) => {
  return prisma.sessionType.delete({ where: { id } });
};

export const listSessionTypes = async (options: {
  eventId?: string;
  lang: string;
  search?: string;
  page?: number;
  limit?: number;
}) => {
  const { eventId, search, page = 1, limit = 10, lang } = options;
  const where: Prisma.SessionTypeWhereInput = {};
  if (eventId) {
    where.eventId = eventId;
  }
  if (search) {
    where.translations = {
      some: { name: { contains: search, mode: "insensitive" } },
    };
  }
  const [total, sessionTypes] = await prisma.$transaction(async (tx) =>
    Promise.all([
      tx.sessionType.count({ where }),
      tx.sessionType.findMany({
        where,
        skip: (page - 1) * limit,
        take: limit,
        include: {
          translations: {
            where: {
              language: {
                code: lang,
              },
            },
          },
        },
      }),
    ])
  );
  const hasNextPage = (page - 1) * limit + limit < total;

  return {
    sessionTypes,
    pagination: {
      total,
      totalPages: Math.ceil(total / limit),
      currentPage: page,
      hasNextPage,
      hasPreviousPage: page > 1,
    },
  };
};
